module.exports = __webpack_public_path__ + "img/tips_img.b404186f.png";